import React from 'react';

import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { KnzComponentProps } from '../../types';

/**
 * 引用（出典表記付き blockquote）。knz 独自の新規コンポーネント。
 * params: text（joined）、cite（任意, 出典）
 */
export const Quote: React.FC<KnzComponentProps> = ({ node, renderInline }) => {
  const text = (node.params.text as string) ?? '';
  const cite = node.params.cite as string | undefined;

  return (
    <Box
      sx={{
        borderLeft: 3,
        borderColor: 'divider',
        borderRadius: 1,
        pl: 2,
        py: 1,
        bgcolor: 'action.hover',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <FormatQuoteIcon sx={{ fontSize: 18, color: 'text.disabled', mt: 0.3 }} />
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="body2"
            color="text.secondary"
            component="div"
            sx={{ lineHeight: 1.8, fontStyle: 'italic' }}
          >
            {renderInline(text)}
          </Typography>
          {cite && (
            <Typography variant="caption" color="text.disabled" sx={{ mt: 0.5, display: 'block' }}>
              — {cite}
            </Typography>
          )}
        </Box>
      </Stack>
    </Box>
  );
};

export default Quote;
